import { render, staticRenderFns } from "./layout-digital-human.vue?vue&type=template&id=1336a9ff&scoped=true"
import script from "./layout-digital-human.vue?vue&type=script&lang=js"
export * from "./layout-digital-human.vue?vue&type=script&lang=js"
import style0 from "./layout-digital-human.vue?vue&type=style&index=0&id=1336a9ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\wwwroot\\deepcityAI\\user-client-pc\\user-client-common-pc\\node_modules\\@vue\\vue-loader-v15\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1336a9ff",
  null
  
)

export default component.exports